import RejectVaspModal from './RejectVaspModal'

export default RejectVaspModal
